import { useDispatch, useSelector } from "react-redux";
import "./RolePlayDetailComponent.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  fetchRolePlayData,
  fetchRolePlayDataClear,
} from "../../../redux/roleplay/actions";
import _ from "lodash";
import DetailPageBannerHeaderComponent from "../DetailPage/DetailPageBannerHeader/DetailPageBannerHeaderComponent";
import NotFoundComponent from "../NotFound/NotFoundComponent";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import RPDetailBodyComponent from "./RPDetailBodyComponent/RPDetailBodyComponent";
import { getProcureInfo, SessionKeys } from "../../../utils/AppUtils";
import RolePlayParticipateSection from "../../RolePlay/RolePlayParticipateSection";
import RolePlayVideoRecord from "../../RolePlay/RolePlayVideoRecord";
import Loader from "../../Loader/Loader";
import useLogin from "../../../custom-hooks/useLogin";
import ShimmerScreen from "../../Layouts/ShimmerScreen";
import ConfirmModal from "../../modal/ConfirmModal";
import { useTranslation } from "react-i18next";
const RolePlayDetailComponent = () => {
  const dispatch = useDispatch();
  const { isLoggedIn } = useLogin();
  const navigate = useNavigate();
  const { roleplayId } = useParams();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const type = params.get("api_type");
  const {t} = useTranslation();
  const rpDetailData = useSelector((state) => state.rolePlay.rolePlayData);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const [isLoading, setIsLoading] = useState(true);
  const [rpData, setRPData] = useState({});
  const [rpDetail, setRPDetail] = useState({});
  const [breadCrumbData, setBreadCrumbData] = useState([
    { name: t("learn"), active: false, link: "", isLoading: false },
    { name: "rolePlay", active: false, link: "", isLoading: false },
    { name: "-", active: false, link: "", isLoading: true },
  ]);
  const [headerProdData, setHeaderProdData] = useState({});

  const [showModalMsg, setShowModalMsg] = useState({
    error: false,
    message: "",
  });
  const [confirmModal, setConfirmModal] = useState(false);
  const [showGreenTick, setShowGreenTick] = useState(false)

  console.log("ROLEPLAY ID", roleplayId);

  // useEffect(() => {
  //   console.log("modalmsg---", showModalMsg);
  //   setTimeout(() => {
  //     setShowModalMsg({ error: false, message: "" });
  //     setConfirmModal(false);
  //   }, 5000);
  // }, [showModalMsg]);

  useEffect(() => {
    if (roleplayId) {
      fetchRolePlayDetail();
    }
  }, [dispatch, roleplayId, activeLanguage]);

  useEffect(() => {
    console.log(rpDetailData);
    if (!_.isEmpty(rpDetailData)) {
      if (rpDetailData.status === "success") {
        const payload = rpDetailData.payload.payload;
        if (!_.isEmpty(payload)) {
          setRPDetail(formatRPDetail(payload));
          // alert(JSON.stringify(payload.rp_mid))
          setRPData(payload);
          setBreadCrumbData([
            { name: t("learn"), active: false, link: "", isLoading: false },
            {
              name: t("rolePlay"),
              active: false,
              link: "/learn/roleplay?tab=1",
              isLoading: false,
            },
            {
              name: type ? t("My Role plays") : t("Role play scenarios"),
              active: false,
              link: type ? "/learn/roleplay?tab=2" : "/learn/roleplay?tab=1",
              isLoading: false,
            },
            { name: payload.title, active: true, link: "", isLoading: false },
          ]);
        }
      }
      setIsLoading(false);
      dispatch(fetchRolePlayDataClear());
    }
  }, [rpDetailData]);

  const fetchRolePlayDetail = () => {
    dispatch(
      fetchRolePlayData({
        module: "getRolePlayDetail",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplayId,
          language: activeLanguage ? activeLanguage : ""
        },
      })
    );
  };

  const navigateToListing = () => {
    navigate("/learn/roleplay?tab=1");
  };

  const formatRPDetail = (rpData) => {
    let tags = [];
    let footerTags = [];
    let logoURL = "";
    if (!_.isEmpty(rpData.provider)) {
      tags.push(rpData.provider.display_name);
      logoURL = rpData.provider.provider_img;
    }
    tags.push("Role play");
    // if (rpData.roleplay_type) {
    //   footerTags.push(rpData.roleplay_type);
    //   tags.push(_.capitalize(rpData.roleplay_type));
    // }

    let priceInfo = getProcureInfo(rpData.purchased_info);
    priceInfo.isAddToCart = rpData.is_addtocart;
    if (!isLoggedIn) priceInfo.isFree = false;
    setHeaderProdData({
      id: rpData.id,
      title: rpData.title,
      logoURL: logoURL,
      bannerURL: rpData.cover_img_url,
      tagsArray: tags,
      description: rpData.situation,
      duration: "",
      view: "",
      price: priceInfo.price,
      isPaid: priceInfo.isPurchased,
      priceInfo: priceInfo,
      purchaseInfo: rpData.purchased_info,
      banner: rpData.cover_img_url,
    });

    return {
      id: rpData.id,
      rp_mid: rpData.rp_mid,
      title: rpData.title,
      logoURL: logoURL,
      bannerURL: rpData.cover_img_url,
      videoURL: rpData.roleplay_url,
      tagsArray: tags,
      description: rpData.situation,
      instruction: rpData.instruction,
      duration: "",
      isLoading: false,
      purchaseInfo: priceInfo,
    };
  };

  const renderAlertCard = () => {
    return (
      <div
        className={`alert-card d-flex justify-content-center ${
          confirmModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            {!showModalMsg.error ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <g
                  id="Group_5699"
                  data-name="Group 5699"
                  transform="translate(0.498 0.498)"
                >
                  <circle
                    id="Ellipse_222"
                    data-name="Ellipse 222"
                    cx="9"
                    cy="9"
                    r="9"
                    transform="translate(-0.498 -0.498)"
                    fill="#A9C23C"
                  />
                  <path
                    id="Icon_material-done"
                    data-name="Icon material-done"
                    d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                    transform="translate(-3.013 -6.071)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="2"
                  />
                </g>
              </svg>
            ) : (
              ""
            )}
            <p className="m-0">{showModalMsg.message}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setConfirmModal(false);
                setShowModalMsg({ error: false, message: "" });
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };
  const [loaderMsg, setLoaderMsg] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [showModalMsg]);

  return (
    <>
      <Loader
        start={
          sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES"
            ? false
            : isLoading
        }
        msg={loaderMsg}
      />
      {!isLoading &&
      _.isEmpty(rpDetail) &&
      sessionStorage.getItem(SessionKeys.IS_TOUR) !== "YES" ? (
        <NotFoundComponent
          btnAction={() => navigateToListing()}
          btnName={"Explore Role play"}
          showMsg={true}
          showBtn={true}
          width={400}
          height={419}
        />
      ) : (
        <>
          <div class="bannersection bgba">
            {false && (
              <DetailPageBannerHeaderComponent
                tagLine={"Free for you"}
                bannerURL={""}
                btnName=""
                productData={rpDetail}
                showTagLine={true}
                showShareIcon={true}
                showCartBtn={false}
              />
            )}

            {isLoading ? (
              <ShimmerScreen case={"rect"} width={"100%"} height={"358px"} />
            ) : !_.isEmpty(headerProdData) &&
              !headerProdData?.priceInfo?.isFree ? (
              <DetailPageBannerHeaderComponent
                bannerURL={headerProdData?.banner}
                btnName={t("Purchase to unlock")}
                productData={headerProdData}
                showTagLine={!_.isEmpty(headerProdData.priceInfo.showText)}
                showShareIcon={true}
                showCartBtn={true}
                tagLine={`${headerProdData.priceInfo.showText}`}
                rightTagLine={`${
                  headerProdData.purchaseInfo.offer_ends_on_text
                    ? headerProdData.purchaseInfo.offer_ends_on_text
                    : ""
                }`}
                setIsMainPageLoading={() => {}}
              />
            ) : headerProdData.banner ? (
              <>
                <div className="bannerrimg">
                <img src={headerProdData.banner} alt="Banner" className="banner-image" />
              </div>
              </>
            ) : (
              <div className="title-banner bk-grey empty-img w-100 d-flex justify-content-center align-items-center">
                <p
                  dangerouslySetInnerHTML={{
                    __html: rpDetail?.title,
                  }}
                ></p>
              </div>
            )}
          </div>
          <div className="container">
            <BreadCrumbComponent crumbList={breadCrumbData} />
            <div className="position-relative p-2 alert-btm">
              {/* {renderAlertCard()} */}
            </div>
            {sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" ? (
              <img
                id="idRolePlayMyResponse"
                width={800}
                src="/images/myResponse.png"
              />
            ) : (
              rpDetail?.rp_mid && (
                <RPDetailBodyComponent
                  id={roleplayId}
                  title={rpDetail?.title}
                  rp_mid={rpDetail?.rp_mid}
                  logoURL={rpDetail?.logoURL}
                  tagsArray={
                    !_.isEmpty(rpDetail?.tagsArray)
                      ? rpDetail.tagsArray
                      : [1, 2, 3, 4]
                  }
                  description={rpDetail?.description}
                  productData={rpDetail}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  setLoaderMsg={setLoaderMsg}
                  rpData={rpData}
                  setConfirmModal={setConfirmModal}
                  setShowModalMsg={setShowModalMsg}
                  setShowGreenTick={setShowGreenTick}
                />
              )
            )}
          </div>
          <ConfirmModal 
            confirmModal={confirmModal}
            setConfirmModal={setConfirmModal}
            showModalMsg={showModalMsg.message}
            isConfirm={false}
            confirmId={''}
            confirmAction={() => {}}
            isRightIcon={showGreenTick}
          />
        </>
      )}
    </>
  );
};

export default RolePlayDetailComponent;
